import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/auth";

const ProtectedRoutes = () => {
  const auth = useAuth();

  if (
    auth.user === undefined ||
    auth.representedEntity === undefined ||
    auth.isUpdatingDelegation
  ) {
    return null;
  }

  if (auth.user === null) {
    return <Navigate to="/" replace />;
  }

  if (auth.representedEntity === null) {
    return null;
  }

  return <Outlet />;
};

export default ProtectedRoutes;
